import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { PageContent } from 'components/PageStyles';

export const ProjectRoute = styled(Link)`
  text-decoration: none;
`;

export const PlaceholderPageContent = styled(PageContent)`
  margin-top: 70px;
`;
